import { useEffect, useRef } from "react";

export const useExpiryTimer = (
  expiryTimestamp: number | null,
  onExpire: () => void
) => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const onExpireRef = useRef(onExpire);

  // Update the callback reference when it changes
  useEffect(() => {
    onExpireRef.current = onExpire;
  }, [onExpire]);

  useEffect(() => {
    // Clear any existing timer
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    // Set timer if we have a valid expiry timestamp
    if (expiryTimestamp) {
      const now = Date.now();
      const expiryMs = expiryTimestamp * 1000;
      
      if (expiryMs > now) {
        const expiresIn = expiryMs - now;
        
        timerRef.current = setTimeout(() => {
          onExpireRef.current();
        }, expiresIn);
      } else {
        // Timestamp is in the past, trigger expiry immediately
        setTimeout(() => {
          onExpireRef.current();
        }, 100);
      }
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [expiryTimestamp]);
};
